import {
  DEFAULT_FOCUS_STYLES,
  DEFAULT_BORDER_STYLES,
  DEFAULT_THEME_COLORS,
  getBodyFonts,
} from './theme'

export const inputStyles = {
  padding: '8px 12px',
  margin: '4px 0 0',
  width: '100%',
  color: DEFAULT_THEME_COLORS['--theme-color--neutral-10'],
  colorDanger: '#A90F0F',
  borderRadius: DEFAULT_BORDER_STYLES['--theme--border-radius-md'],
  border: DEFAULT_BORDER_STYLES['--theme--border-input'],
  ...getBodyFonts(),
  '&:focus': {
    outline: DEFAULT_FOCUS_STYLES['--theme--focus-outline'],
    outlineOffset: '1px',
  },
  '&::-webkit-search-cancel-button': {
    '-webkit-appearance': 'none',
  },
}

export const errorStyles = (props: { errored?: boolean }) => {
  const { errored } = props

  return {
    backgroundColor: errored ? DEFAULT_THEME_COLORS['--theme-color--status-error-lightest'] : '',
    border: errored ? DEFAULT_BORDER_STYLES['--theme--border-input-error'] : '',
    '&:hover': {
      backgroundColor: errored
        ? DEFAULT_THEME_COLORS['--theme-color--status-error-lightest']
        : DEFAULT_THEME_COLORS['--theme-color--neutral-95'],
      border: errored
        ? DEFAULT_BORDER_STYLES['--theme--border-input-error']
        : DEFAULT_BORDER_STYLES['--theme--border-input-hover'],
    },
  }
}
